module.exports = __webpack_public_path__ + "img/down-arrow-white.svg";